import { getApiClient } from 'adapter/out/client/apiClient';
import CreateStoredAnalysisCriteria from 'use-case/storedAnalysis/create/createStoredAnalysisCriteria';
import StoredAnalysis from 'domain/entity/storedAnalysis';

const createStoredAnalysisApiClient = getApiClient(
    () => `dashboards/stored-analyses`,
    StoredAnalysis,
    (clientCriteria: CreateStoredAnalysisCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseCreateStoredAnalysisCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

const parseCreateStoredAnalysisCriteria = (criteria: CreateStoredAnalysisCriteria) => ({
    name: criteria.name,
});

export default createStoredAnalysisApiClient;
